import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {MaterialModule} from '../material/material.module';
import {SafeSvgModule} from './safe-svg.module';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {AttributeFilterComponent} from './attribute-filter/attribute-filter.component';
import {ListingAttributesPanelComponent} from './listing-attributes-panel/listing-attributes-panel.component';

@NgModule({
  declarations: [
    SidebarComponent,
    AttributeFilterComponent,
    ListingAttributesPanelComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxSliderModule,
    MaterialModule,
    SafeSvgModule,
  ],
  exports: [
    SidebarComponent,
    AttributeFilterComponent,
    ListingAttributesPanelComponent,
    SafeSvgModule,
  ],
})
export class BrowseSharedModule {}
